import RainbowText, { Position } from "components/RainbowText";
import { chart1 } from "theme/palette";
import theme from "theme";

interface AnnotatedBlockProps {
  text: string;
  entities: Array<{ offsetStart: number; offsetEnd: number }>;
  mainHit?: Position;
}

const AnnotatedBlock = (props: AnnotatedBlockProps) => {
  const { text, entities } = props;
  const entityAnnotations = entities.map((ent) => ({
    start: ent.offsetStart,
    end: ent.offsetEnd,
    tag: "",
    color: chart1.light,
  }));
  const mainAnnotation = props.mainHit
    ? [
        {
          start: props.mainHit.start,
          end: props.mainHit.end,
          tag: "",
          highlight: true,
          color: "yellow",
          popover: undefined,
        },
      ]
    : [];

  const annotations = entityAnnotations.concat(mainAnnotation);

  return (
    <div>
      <RainbowText
        text={text}
        annotations={annotations}
        sx={{
          fontFamily: "Inter",
          fontSize: "0.75rem",
          margin: theme.spacing(0.5, 0),
        }}
      />
    </div>
  );
};

export default AnnotatedBlock;
